import { Component, OnInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';
import { CustomFormUtilsService } from './../../custom-form-utils.service';

/**
 * Componente que redneriza el editor de Grupos de dependencia de un customform
 */
@Component({
  template: `
        <ng-multiselect-dropdown
        placeholder="Grupos"
      [settings]="dropdownSettings"
      [data]="listaCampos"
      (onSelect)="changeDependencies()"
      (onDeSelect)="changeDependencies()"
            [(ngModel)]="listado">
    </ng-multiselect-dropdown>
  `,
})

export class DependencyGroupComponent extends DefaultEditor implements OnInit {
  dropdownSettings = {
    singleSelection: false,
    allowSearchFilter: true,
    searchPlaceholderText:"Buscar",
    enableCheckAll:false
  };
  listado:any = {};
  renderValue:String;
  listaCampos:any;
  constructor(
    private customFormUtilsService:CustomFormUtilsService,
  ) {
    super();
  }

  async ngOnInit(): Promise<void> {
    this.listado = this.cell.newValue;
    this.listaCampos = await this.customFormUtilsService.getFormFieldList();
    this.listaCampos.sort()
  }

  changeDependencies(){
    this.cell.newValue = this.listado;
  }


}
